module.exports = __webpack_public_path__ + "img/premio4.8aca9195.png";